/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { makeStyles, tokens } from "../../packages/fluent9";

/**
 * Gets the styles for the ErrorPage component.
 * @returns The styles for the ErrorPage component.
 */
export const useStyles = makeStyles({
    grid: {
        display: "grid",
        gridTemplateColumns: "minmax(15rem, 25rem) minmax(15rem, 1fr)",
        gridTemplateRows: "1fr",
        height: "100%",
        width: "100%"
    },
    left: {
        alignContent: "center",
        borderRightColor: tokens.colorNeutralStroke2,
        borderRightStyle: "solid",
        borderRightWidth: tokens.strokeWidthThin,
        gridColumnEnd: "2",
        gridColumnStart: "1",
        gridRowEnd: "2",
        gridRowStart: "1",
        overflowX: "auto",
        overflowY: "auto",
        paddingBottom: tokens.spacingVerticalS,
        paddingLeft: tokens.spacingHorizontalXS,
        paddingRight: tokens.spacingHorizontalXS,
        paddingTop: tokens.spacingVerticalS,
        textAlign: "center"
    },
    right: {
        alignContent: "center",
        borderRightColor: tokens.colorNeutralStroke2,
        borderRightStyle: "solid",
        borderRightWidth: tokens.strokeWidthThin,
        gridColumnEnd: "3",
        gridColumnStart: "2",
        gridRowEnd: "2",
        gridRowStart: "1",
        overflowX: "auto",
        overflowY: "auto",
        paddingBottom: tokens.spacingVerticalSNudge,
        paddingLeft: tokens.spacingHorizontalS,
        paddingRight: tokens.spacingHorizontalS,
        paddingTop: tokens.spacingVerticalSNudge,
        textAlign: "center"
    }
});
